<div class="information-view-and-edit">
  @if (!isEditing) {
    <app-object-view
      class="information-view-and-edit__view"
      [hideSectionTitle]="true"
      [objectId]="sectionsContainer.rootObject.artifact_id"
      [sectionsContainer]="sectionsContainer"
      [templateGroupId]="sectionsContainer.templateGroupId"
    ></app-object-view>
  }
  @else {
    <div class="information-view-and-edit__edit">
      @if (sectionsContainer) {
        <app-object-edit
          [sectionsContainer]="sectionsContainer"
        ></app-object-edit>
      }
    </div>
  }
</div>
